import { Injectable } from '@angular/core';
import { PropertyBookletInsulationType } from './property-booklet-insulation-card.component';

@Injectable()
export class PropertyBookletInsulationService {
  public static getTitle(type: PropertyBookletInsulationType): string {
    let title = '';
    switch (type) {
      case PropertyBookletInsulationType.roof:
        title = 'Toiture';
        break;
      case PropertyBookletInsulationType.walls:
        title = 'Murs extérieurs';
        break;
      case PropertyBookletInsulationType.floor:
        title = 'Planchers bas';
        break;
      case PropertyBookletInsulationType.windows:
        title = 'Vitres et portes';
        break;
      default:
        console.error('PropertyBookletBuildingCardComponent.setTitle(): Undefined title');
        break;
    }
    return title;
  }

  public static getSummary(type: PropertyBookletInsulationType): string {
    let summary = "Ajoutez la fiche produit et le descriptifs de l'isolation ";
    switch (type) {
      case PropertyBookletInsulationType.roof:
        summary += 'toiture';
        break;
      case PropertyBookletInsulationType.walls:
        summary += 'des murs';
        break;
      case PropertyBookletInsulationType.floor:
        summary += 'plancher';
        break;
      case PropertyBookletInsulationType.windows:
        summary += 'vitres et portes';
        break;
      default:
        console.error('PropertyBookletBuildingCardComponent.getSummary(): Undefined summary');
        break;
    }
    return summary;
  }
}
